/* eslint-disable max-len */
import 'react';

const SavedSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
            <path id="wiki_SavedSvg__a" d="M0 0h12v12H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="wiki_SavedSvg__b" fill="#fff">
                <use xlinkHref="#wiki_SavedSvg__a" />
            </mask>
            <circle stroke="#878D99" strokeWidth="1.2" strokeLinejoin="round" mask="url(#wiki_SavedSvg__b)" cx="6" cy="6" r="5" />
            <path stroke="#878D99" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" mask="url(#wiki_SavedSvg__b)" d="M4.047 6.056l1.631 1.483L7.877 5" />
        </g>
    </svg>
);

export default SavedSvg;
